import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { findRecord } from '@warp-drive/utilities/json-api';
import type { TasProgramInstanceExtension as TasProgramInstanceModel } from 'tio-data/data/resources/tas-program-instance.ext';
import type { Store } from '@warp-drive/core';

export default class AuthenticatedAdminTuitionAssistanceProgramInstancesShowRoute extends Route {
  @service declare store: Store;

  includes = [
    'tas-applications.tas-courses',
    'tas-applications.tags',
    'tas-applications.comments.person',
    'tas-applications.tas-assistances',
    'tas-program-template.tas-field-options',
    'employee.person',
    'employee.company.comments',
    'employee.tas-participant',
    'tas-assets.attachments',
    'comments.person',
  ];

  async model(params: { tas_program_instance_id: string }) {
    const { tas_program_instance_id } = params;

    const { content } = (await this.store.request(
      findRecord<TasProgramInstanceModel>('tas-program-instance', tas_program_instance_id, {
        include: this.includes.join(','),
        reload: true,
      })
    )) as { content: { data: TasProgramInstanceModel } };
    return content.data;
  }
}
